import type { OriginalOptions } from '../types';

export const OriginalOptionsService = Symbol.for('OriginalOptionsService');

export interface OriginalOptionsService {
    initialize: (patentLangList: string[]) => OriginalOptions;
}
